import React from 'react';

import { canUseDOM } from '@lib/canUseDOM';

import type { Platform, PlatformObject } from './typings';
import { PlatformContext } from './PlatformContext';

export function withPlatform<Props extends object>(obj: PlatformObject<React.ComponentType<Props>>): React.ComponentType<Props> {
    return props => {
        let platform: Platform;

        if (canUseDOM) {
            platform = window.RentApp.platform;
        } else {
            platform = React.useContext(PlatformContext);
        }

        const Component = obj[platform];

        return React.createElement(Component, props);
    };
}
